import textFns from '@gef-ui/validation-functions/text';
import createValidationFn from '../../createValidationFn';
/**
 * Validate string
 *
 * @documented
 * @category Text
 * @import import { isString } from '@gef-ui/form-core/validations/validationFunctions/text'
 * @param {Number} [minLength]
 * @param {Number} [maxLength]
 * @param {Number} [length]
 * @returns {String} errMessage
 *
 */ export const isString = createValidationFn(textFns.isString);
/**
 * Validate email
 *
 * @documented
 * @category Text
 * @import import { isEmail } from '@gef-ui/form-core/validations/validationFunctions/text'
 * @returns {String} errMessage
 *
 */ export const isEmail = createValidationFn(textFns.isEmail);
/**
 * Validate email by dmo standard
 *
 * @documented
 * @category Text
 * @import import { isEmailDMO } from '@gef-ui/form-core/validations/validationFunctions/text'
 * @returns {String} errMessage
 *
 */ export const isEmailDMO = createValidationFn(textFns.isEmailDMO);
/**
 * Validate company name
 *
 * @documented
 * @category Text
 * @import import { isCompanyName } from '@gef-ui/form-core/validations/validationFunctions/text'
 * @returns {String} errMessage
 *
 */ export const isCompanyName = createValidationFn(textFns.isCompanyName);
/**
 * Validate phone number
 *
 * @documented
 * @category Text
 * @import import { isPhoneNumber } from '@gef-ui/form-core/validations/validationFunctions/text'
 * @returns {String} errMessage
 *
 */ export const isPhoneNumber = createValidationFn(textFns.isPhoneNumber);
/**
 * hasNoWhitespace
 *
 * @documented
 * @category Text
 * @import import { hasNoWhitespace } from '@gef-ui/form-core/validations/validationFunctions/text'
 * @returns {String} errMessage
 *
 */ export const hasNoWhitespace = createValidationFn(textFns.hasNoWhitespace);
/**
 * hasNoPunctation
 *
 * @documented
 * @category Text
 * @import import { hasNoPunctation } from '@gef-ui/form-core/validations/validationFunctions/text'
 * @param {Object} input
 * @param {Boolean} [input.strict=true]
 * @returns {String} errMessage
 *
 */ export const hasNoPunctation = createValidationFn(textFns.hasNoPunctation);
/**
 * isAlphanumerical
 *
 * @documented
 * @category Text
 * @import import { isAlphanumerical } from '@gef-ui/form-core/validations/validationFunctions/text'
 * @param {Object} input
 * @param {Boolean} [input.onlyUpperCase=false]
 * @param {Boolean} [input.onlyLowerCase=false]
 * @returns {String} errMessage
 *
 */ export const isAlphanumerical = createValidationFn(textFns.isAlphanumerical);
/**
 * allow only chars in specified regexp
 *
 * @documented
 * @category Text
 * @import import { onlyAllowedChars } from '@gef-ui/form-core/validations/validationFunctions/text'
 * @param {Object} input
 * @param {RegExp} input.regex
 * @param {String} [input.messageKey=onlyAllowedChars]
 * @returns {String} errMessage
 *
 */ export const onlyAllowedChars = createValidationFn(textFns.onlyAllowedChars);
/**
 * allow only chars outside of specified regexp
 *
 * @documented
 * @category Text
 * @import import { onlyAllowedCharsDisjoint } from '@gef-ui/form-core/validations/validationFunctions/text'
 * @param {Object} input
 * @param {RegExp} input.regex
 * @param {String} [input.messageKey=onlyAllowedChars]
 * @returns {String} errMessage
 *
 */ export const onlyAllowedCharsDisjoint = createValidationFn(textFns.onlyAllowedCharsDisjoint);
/**
 * validate vin according to https://en.wikipedia.org/wiki/Vehicle_identification_number
 *
 * @documented
 * @category Text
 * @import import { isVin } from '@gef-ui/form-core/validations/validationFunctions/text'
 * @returns {String} errMessage
 *
 */ export const isVin = createValidationFn(textFns.isVin);
/**
 * validate vat
 *
 * @documented
 * @category Text
 * @import import { isVat } from '@gef-ui/form-core/validations/validationFunctions/text'
 * @returns {String} errMessage
 *
 */ export const isVat = createValidationFn(textFns.isVat);
/**
 * validate street and orientation number when in one field. like street/orientation
 *
 * @documented
 * @category Text
 * @import import { isStreetOrientationNumber } from '@gef-ui/form-core/validations/validationFunctions/text'
 * @returns {String} errMessage
 *
 */ export const isStreetOrientationNumber = createValidationFn(textFns.isStreetOrientationNumber);
